import { useReducer } from "react";
import { useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { userActions } from "../store/user-slice";
import useFetch from './../hook/useFetch';
import parse from 'html-react-parser';
import { notificationActions } from "../store/notification-slice";

export default function Signup() {

    let componentReducer = (state, action) => {

        switch (action.type) {
            case 'email':
                return { ...state, email: action.data }
            case 'password':
                return { ...state, password: action.data }
                case 'confirmation_password':
                    return {...state,confirmation_password:action.data}
                    case 'username':
                        return {...state,username:action.data}

        }

    }

    const [componentState, componentDispatch] = useReducer(componentReducer, {
        email: null,
        password: null,
        confirmation_password:null,
        username:null
    })

    let dispatch = useDispatch()

    const { error, post } = useFetch()

    let navigate=useNavigate()

    return <div className="login-container" >
        <form className="login-form shadow" onSubmit={(e) => {
            e.preventDefault()

            post('/user', {
                email: componentState.email,
                password: componentState.password,
                confirmation_password:componentState.confirmation_password,
                username:componentState.username,
                redirect:process.env.REACT_APP_BASE_URL

            }, null, (data) => {
               dispatch(notificationActions.setNotification({
                message:'please check your mailbox to activate you account',
                status:true
               }))
                navigate('/')
            })
        }} >
           
           {error &&
                    <div className="alert bg-danger " >
                        <p>{parse(error)}</p>
                    </div>
                }

                <div className="form-group">
                <label htmlFor="exampleInputEmail1">Username</label>
                <input type="text" className="form-control" placeholder="Username" defaultValue={componentState.username} onInput={(e) => {
                    componentDispatch(
                        {
                            type: 'username',
                            data: e.target.value
                        }
                    )
                }} required />
            
            </div>
            <div className="form-group">
                <label htmlFor="exampleInputEmail1">Email address</label>
                <input type="email" className="form-control" placeholder="Email" defaultValue={componentState.email} onInput={(e) => {
                    componentDispatch(
                        {
                            type: 'email',
                            data: e.target.value
                        }
                    )
                }} required />

            </div>
            <div className="form-group">
                <label htmlFor="exampleInputPassword1">Password</label>
                <input type="password" className="form-control" placeholder="Password" defaultValue={componentState.password} onInput={(e) => {
                    componentDispatch(
                        {
                            type: 'password',
                            data: e.target.value
                        }
                    )
                }} required />
            </div>

            <div className="form-group">
                <label htmlFor="exampleInputPassword1">Password Confirmation</label>
                <input type="password" className="form-control" placeholder="Password Confirmation" defaultValue={componentState.confirmation_password} onInput={(e) => {
                    componentDispatch(
                        {
                            type: 'confirmation_password',
                            data: e.target.value
                        }
                    )
                }} required />
            </div>


            <button type="submit" className="btn btn-primary" >Register</button>
            <Link className="btn" to='/login' >Login</Link>
        </form>
    </div>

}